import type { VoidFunctionComponent } from 'react';
import { window } from '../../globals';
import AppError from './AppError';

type Props = {
  // optional heading to display
  heading?: string;
};

/**
 * 404 component. Wrapper around generic AppError component.
 */
const NotFound: VoidFunctionComponent<Props> = ({ heading }) => (
  <AppError
    heading={heading || 'Not Found'}
    text="Either this page does not exist or you do not have permission access to it"
    isLoggedIn={!!window.user}
  />
);

export default NotFound;
